import config from "../config/config.inc";
import './styles/main.scss';
import * as bootstrap from 'bootstrap';
import App from "./js/app/app";

window.bootstrap = bootstrap;

const app = new App(config);
app.start();
